import {
  componentProps,
  CasSelect,
  CasRHFSelect,
  CasEntitySelectProps,
} from 'src/compass/shared/components';
import { useRetrieveSelectListOptions } from 'src/compass/shared/components/CasSelect/CasEntitySelect';
import { EntityListOptionsProps } from 'src/compass/shared/hooks/reactQuery/useRetrieveEntityListOptions';
import prependAllOption from 'src/compass/shared/util/prependAllOption';
import { emptyOption } from 'src/compass/shared/util/prependEmptyOption';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';

const entity = 'Entity/TouchpointFrequencies/Select';
export const UnassignedOption_Name = '(Unassigned)';
export const NotExcludedOption_Name = '(Not Excluded)';

export function useTouchpointFrequencyOptions(props: EntityListOptionsProps) {
  return useRetrieveSelectListOptions(entity, { staleTime: Infinity, ...props });
}

export function TouchpointFrequencyEditSelect(props: componentProps) {
  const { options } = useTouchpointFrequencyOptions({});
  const optionsWithUnassigned = [{ name: UnassignedOption_Name, id: null }, ...options];

  return <CasSelect {...props} options={optionsWithUnassigned} />;
}

export function TouchpointFrequencySelect(props: componentProps) {
  const { options } = useTouchpointFrequencyOptions({});
  const optionsWithAllAndUnassigned = prependAllOption([
    emptyOption(UnassignedOption_Name),
    ...StringsToOptions([NotExcludedOption_Name]),
    ...options,
  ]);

  return <CasSelect {...props} options={optionsWithAllAndUnassigned} />;
}

export function RHFTouchpointFrequencySelect(props: CasEntitySelectProps) {
  const { options } = useTouchpointFrequencyOptions({});
  
  return <CasRHFSelect {...props} options={options} />;
}